import React from "react";
import Swiper from "..";

import { BannerItem } from "../../../services/bannerServices";

import { Skeleton } from "../../../pages/Talk";
import DefaultBanner from "../../Banner";

type Props = {
  bannerList: BannerItem[];
  onSlideChange?: (index: number) => void;
  isLoading?: boolean;
};

export default function MainBanner({
  bannerList,
  onSlideChange,
  isLoading,
}: Props) {
  const blankBanner = {
    linkType: "NULL",
    linkUrl: "",
    file: "",
  } as BannerItem;

  const renderer = (item: BannerItem) => {
    return isLoading === true ? (
      <Skeleton className="w-full h-[175px] rounded-lg" />
    ) : (
      <DefaultBanner
        position="MAINROLL"
        item={item}
        className="rounded-2xl mb-2"
      />
    );
  };

  return (
    <Swiper
      slidesPerView={1.4}
      slidesOffsetBefore={0}
      list={
        isLoading === true
          ? [blankBanner, blankBanner, blankBanner]
          : bannerList
      }
      renderer={renderer}
      onSlideChange={(swiper: any) => {
        if (onSlideChange) {
          onSlideChange(swiper.activeIndex);
        }
      }}
      autoplay={true}
    />
  );
}
